import React from 'react'

import { rem as px2rem } from '../../../utils/remUtils'

import styles from './CouponCardBox.module.css'
import cx from '../../../utils/className'


const CouponCardBox = props => {
  const {
    renderTopContent = () => null,
    renderBottomContent = () => null
  } = props

  const topStyle = {}
  const bottomStyle = {}
  const circleStyle = {}

  const { backgroundColor, borderRadius, borderColor, circleBackgroundColor } = props

  if (backgroundColor) {
    topStyle.backgroundColor = backgroundColor
    bottomStyle.backgroundColor = backgroundColor
  }

  if (borderColor) {
    const borderStyle = `${px2rem(1)} solid ${borderColor}`

    topStyle.border = borderStyle
    topStyle.borderBottom = 'none'

    bottomStyle.border = borderStyle
    bottomStyle.borderTop = 'none'

    circleStyle.border = borderStyle
  }

  if (borderRadius) {
    topStyle.borderRadius = `${px2rem(borderRadius)} ${px2rem(borderRadius)} 0 0`
    bottomStyle.borderRadius = `0 0 ${px2rem(borderRadius)} ${px2rem(borderRadius)}`
  }

  if (circleBackgroundColor) {
    circleStyle.backgroundColor = circleBackgroundColor
  }


  return (
    <div className={cx(styles.wrapper, props.className)}>
      <div className={styles.topContent}>
        <main style={topStyle}>{renderTopContent()}</main>
        <div style={circleStyle} className={cx(styles.circle, borderColor && styles.withBorder)} />
        <div style={circleStyle} className={cx(styles.circle, styles.rightCircle, props.borderColor && styles.withBorder)} />
      </div>
      <div className={styles.bottomContent}>
        <main style={bottomStyle}>{renderBottomContent()}</main>
      </div>
    </div>
  )
}

export default CouponCardBox